import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights = null;

export const initAzureAnalytics = (instrumentationKey, userId = null) => {
  if (!instrumentationKey) {
    // eslint-disable-next-line no-console
    console.warn("Instrumentation key is required to initialize Azure Analytics.");
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey,
      enableAutoRouteTracking: false, // manual tracking preferred
      disableFetchTracking: true,
      disableAjaxTracking: true,
      //  maxBatchInterval: 15000, // send in batches every 15s
      // samplingPercentage: 100,
    },
  });

  appInsights.loadAppInsights();

  if (userId) {
    setUserId(userId);
  }

  appInsights.addTelemetryInitializer(env => {
    env.tags = env.tags || [];
    env.tags["ai.cloud.role"] = "WaveProInsights";
  });
};

export const trackComponentView = (name, additionalProps = {}) => {
  if (!appInsights) return;

  appInsights.trackPageView({
    name,
    properties: {
      timestamp: new Date().toISOString(),
      ...additionalProps,
    },
  });
};

export const trackPageView = (name, url = "") => {
  if (!appInsights) return;

  appInsights.trackPageView({ name, uri: url });
};

export const trackEvent = (name, properties = {}) => {
  if (!appInsights) return;

  appInsights.trackEvent({ name, properties });
};

export const setUser = userId => {
  if (!appInsights) return;

  setUserId(userId);
};

export const clearUser = () => {
  if (!appInsights) return;

  appInsights.clearAuthenticatedUserContext();
};

const setUserId = userId => {
  if (!appInsights) return;

  appInsights.setAuthenticatedUserContext(userId);
  appInsights.addTelemetryInitializer(env => {
    env.tags = env.tags || [];
    env.tags["ai.user.id"] = userId;
  });
};

export default {
  initAzureAnalytics,
  trackComponentView,
  trackPageView,
  trackEvent,
  setUser,
  clearUser,
};
